import $ from 'jquery'
import 'jquery-ui/ui/widgets/sortable'
import 'jquery-ui/ui/disable-selection'

$(document).on("turbolinks:load",function(){
	$("#function_11_3").each(function(form) {
		var that = this;
		//messaggio errore se nessuna residenza selezionata
		$(that).submit(function(e) {
			var checked = $('input.igrad-check:checkbox:checked').length;
	    	if(checked == 0) 
	    	{	Window.totem_global.display_error('Seleziona almeno una residenza!');
	    		e.preventDefault();
	    	}
		});
		//dopo un submit a vuoto il pulsante si disabilita lo debbo rialbilitare se un checkbox è cliccato
		$(that).find('input[type=checkbox].igrad-check').click(function(){
			$(this).closest('form').find('input[type=submit]').removeAttr('disabled');
		});
		//riordinio delle linee di tabella
		$(that).find("table .row_up,table .row_down").click(function(e){
	        e.preventDefault();
	        var row = $(this).parents("tr");
	        if ($(this).is(".row_up")) {
	        	row.insertBefore(row.prevAll('tr:first'));
	        }
	        else
	        {	row.insertAfter(row.nextAll('tr:first'));
	        }
	        //ripristino le posizioni di preferenza
	        $('input[type=hidden].ipref', $(this).closest('tbody')).each(function (i) {
				$(this).val(i + 1);
			}); 
		});
		//questo si potrebbe rimuoere 
		$(that).find('input[type=checkbox].igrad-check.is-invalid').each(function(){
			$(this).parent().find('label').text($(this).data('error-msg'));
		});

		var fixHelperModified = function(e, tr) {
			var $originals = tr.children();
			var $helper = tr.clone();
			$helper.children().each(function(index) {
				$(this).width($originals.eq(index).width())
			});
			return $helper;
		};
		var updateIndex = function(e, ui) {
			$('input[type=hidden].ipref', ui.item.parent()).each(function (i) {
				$(this).val(i + 1);
			});
		};

		if($(that).find('table').hasClass('table-sortable'))
		{	$(this).find("tbody").sortable({
				helper: fixHelperModified,
				stop: updateIndex,
				handle: 'td:not(.no_handle)'
			}).disableSelection();
		}
	});	
});